import { memo } from 'react'
import { VIEWS } from '../../../containers/auth/modals'
import Link from 'next/link'
import { useAuth } from '../../../contexts/auth'
import { ROUTES } from '../../../constants'
import Facebook from '../../svg/facebook'
import Twitter from '../../svg/twitter'
import Instagram from '../../svg/instagram'
import Reddit from '../../svg/reddit'
import { Button } from '../../button'

const Footer = memo(() => {
  const [{ isAuthenticated, userDetails }, { setAuthModal }] = useAuth()

  return (
    <footer>
      <div className='container'>
        <div className='topGrid'>
          <div className='brand'>
            <div className='brandTitle'>
              <img alt="Privauto icon" width="200" src="/images/privauto-icon.png"/>
            </div>
            <p className='brandDesc'>
              Sell privately. Close securely. We help you complete the transaction without the hassle.
            </p>

            <div className='socialNetworks'>
              <a
                aria-label='facebook page'
                href='https://facebook.com/DrivrzXchange-101501255263506'
                target='_blank'
                rel='nofollow noopener noreferrer'
              >
                <Facebook />
              </a>
              <a
                aria-label='twitter page'
                href='https://twitter.com/DrivrzXchange'
                target='_blank'
                rel='nofollow noopener noreferrer'
              >
                <Twitter />
              </a>
              <a
                aria-label='Reddit page'
                href='https://reddit.com/r/DrivrzXchange/'
                target='_blank'
                rel='nofollow noopener noreferrer'
              >
                <Reddit />
              </a>
              <a
                aria-label='instagram page'
                href='https://instagram.com/drivrzxchange/'
                target='_blank'
                rel='nofollow noopener noreferrer'
              >
                <Instagram />
              </a>
            </div>
          </div>

          <div className='col'>
            <div className='colTitle'>Marketplace</div>
            <ul className='linkList'>
              <li>
                <Link legacyBehavior href={ROUTES.Buy}>
                  <a>Buy</a>
                </Link>
              </li>
              <li>
                <Link legacyBehavior href={ROUTES.Sell}>
                  <a>Sell</a>
                </Link>
              </li>
              <li>
                <Link legacyBehavior href={ROUTES.Search}>
                  <a>Search</a>
                </Link>
              </li>
              {userDetails?.verified && (
                <li>
                  <Link legacyBehavior href={ROUTES.Account}>
                    <a>My Vehicles</a>
                  </Link>
                </li>
              )}
            </ul>
            {!isAuthenticated && (
              <div className="footerAuthorization">
                <Link legacyBehavior href={ROUTES.Dealers}>
                  <a className='signUpBtn'>Dealer Sign Up</a>
                </Link>
                <Button
                  onClick={() => setAuthModal({ open: true, view: VIEWS.Login })}
                >
                  Sign In
                </Button>
              </div>
            )}
          </div>

          <div className='col'>
            <div className='colTitle'>Company</div>
            <ul className='linkList'>
              <li>
                <Link legacyBehavior href={ROUTES.Membership}>
                  <a>Memberships</a>
                </Link>
              </li>
              <li>
                <Link legacyBehavior href={ROUTES.About}>
                  <a>About</a>
                </Link>
              </li>
              <li>
                <Link legacyBehavior href={ROUTES.Contact}>
                  <a>Contact</a>
                </Link>
              </li>
              <li>
                <Link legacyBehavior href={ROUTES.NeedHelp}>
                  <a>Help</a>
                </Link>
              </li>
            </ul>
          </div>
        </div>

        <div className='bottomBar'>
          <div className='copyRight'>
            <span>Copyright 2021 D2D Auto Auction LLC | All Rights Reserved</span>
          </div>
        </div>
      </div>

      <style jsx>{`
        footer {
          background: var(--secondary-bg-color);
          color: #fff;
          font-size: 1.6rem;
        }

        a,
        button {
          color: #fff;
        }

        .container {
          max-width: 192rem;
          width: 100%;
          margin: 0 auto;
          padding: 0 4rem;
        }

        .topGrid {
          padding: 5.2rem 0 3.2rem;
          display: grid;
          grid-template-columns: 1.35fr 1fr 1fr;
          gap: 4.2rem;
          border-bottom: 1px solid #47648f;
        }

        .brandDesc {
          margin: 1.2rem 0 2.2rem;
          color: rgba(255, 255, 255, 0.7);
          line-height: 1.55;
          max-width: 44rem;
        }

        .colTitle {
          font-weight: 800;
          font-size: 1.4rem;
          letter-spacing: 0.3px;
          text-transform: uppercase;
          opacity: 0.95;
          position: relative;
          padding-bottom: 1.4rem;
          margin-bottom: 1.8rem;
        }

        .colTitle:after {
          content: '';
          position: absolute;
          left: 0;
          bottom: 0;
          width: 3.6rem;
          height: 2px;
          background: var(--primary-color);
          opacity: 0.9;
        }

        .linkList {
          list-style: none;
          padding: 0;
          margin: 0;
        }

        .linkList li a {
          display: inline-block;
          padding: 1.15rem 0;
          color: rgba(255, 255, 255, 0.85);
          border-bottom: 1px solid rgba(255, 255, 255, 0.08);
          width: 100%;
          transition: color 0.15s ease, border-color 0.15s ease;
        }

        .linkList li a:hover {
          color: #fff;
          border-bottom-color: rgba(255, 255, 255, 0.16);
        }

        .muted {
          margin: 0 0 1.6rem;
          color: rgba(255, 255, 255, 0.7);
          line-height: 1.5;
        }

        .tinyMuted {
          margin: 1.2rem 0 0;
          font-size: 1.2rem;
          color: rgba(255, 255, 255, 0.55);
        }

        .socialNetworks {
          display: flex;
          align-items: center;
          gap: 1.6rem;
        }

        .socialNetworks a {
          display: inline-flex;
          align-items: center;
          justify-content: center;
        }

        .socialNetworks :global(svg) {
          fill: var(--primary-color);
          background: #fff;
          border-radius: 50%;
        }

        .footerAuthorization {
          display: flex;
          gap: 10px;
          margin-top: 1rem;
            
            .signUpBtn {
              padding: 1rem 3.2rem;
              border-radius: 4.1rem;
              font-size: 1.4rem;
              border: 1px solid #47648f;
              font-weight: bold;
              white-space: nowrap;
              transition: all 0.15s ease-in-out;

              &:hover {
                background: rgba(255, 255, 255, 0.1);
              }

              &:focus {
                background: rgba(255, 255, 255, 0.07);
              }
            }

            :global(button) {
              font-size: 1.4rem;
            }
        }

        .newsletterForm {
          display: flex;
          align-items: center;
          border: 1px solid rgba(255, 255, 255, 0.14);
          border-radius: 1.2rem;
          overflow: hidden;
          background: rgba(0, 0, 0, 0.15);
        }

        .newsletterInput {
          flex: 1;
          height: 4.6rem;
          padding: 0 1.4rem;
          outline: none;
          border: 0;
          background: transparent;
          color: #fff;
          font-size: 1.4rem;
        }

        .newsletterInput::placeholder {
          color: rgba(255, 255, 255, 0.55);
        }

        .newsletterBtn {
          height: 4.6rem;
          padding: 0 1.8rem;
          border: 0;
          background: var(--primary-color);
          font-weight: 800;
          cursor: pointer;
          transition: transform 0.12s ease, filter 0.12s ease;
        }

        .newsletterBtn:hover {
          filter: brightness(1.05);
          transform: translateY(-1px);
        }

        .bottomBar {
          padding: 2.2rem 0 3.2rem;
          display: flex;
          align-items: center;
          justify-content: space-between;
          gap: 2rem;
        }

        .copyRight span {
          color: rgba(255, 255, 255, 0.65);
        }
      `}</style>

      {/* Mobile query */}
      <style jsx>{`
        @media (max-width: 1024px) {
          footer {
            font-size: 1.2rem;
          }

          .container {
            padding: 0 1.2rem;
          }

          .topGrid {
            display: flex;
            flex-direction: column;
            gap: 2.4rem;
            padding: 3.2rem 0 2.2rem;
          }

          .brandDesc {
            display: none;
          }

          .socialNetworks {
            margin-top: 1.2rem;
            gap: 1.2rem;
          }

          .newsletter {
            display: none;
          }

          .linkList li a {
            padding: 0.95rem 0;
          }

          .bottomBar {
            flex-direction: column;
            align-items: flex-start;
            gap: 0.8rem;
            padding: 1.6rem 0 2.2rem;
          }

          .footerAuthorization {
            display: none;
          }
        }

        @media (max-width: 640px) {
          .topGrid {
            grid-template-columns: 1fr;
            gap: 2rem;
          }

          .socialNetworks {
            justify-content: flex-start;
          }
        }
      `}</style>
    </footer>
  )
})

export default Footer